import React from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
  CircularProgress,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import BasePaper from "components/Base/BasePaper";
import { RectangularTextButton } from "components/Base/Buttons";

interface DataImportStepperBarProps {
  title?: string;
  steps: string[];
  activeStep: number;
  onBack: () => void;
  onNext: () => void;
  disableNext?: boolean;
  showNextLoading?: boolean;
}

const DataImportStepperBar: React.FC<DataImportStepperBarProps> = ({
  title,
  steps,
  activeStep,
  onBack,
  onNext,
  disableNext = false,
  showNextLoading = false,
}) => {
  return (
    <BasePaper>
      {title && (
        <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
          {title}
        </Typography>
      )}

      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{ width: "100%" }}
        wrap="nowrap"
      >
        <Grid2 size={2}>
          <RectangularTextButton
            colour="clear"
            disabled={activeStep === 0}
            onClick={onBack}
            sx={{ mr: 1 }}
          >
            Back
          </RectangularTextButton>
        </Grid2>

        <Grid2 size={8}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{ maxWidth: "100%" }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid2>

        <Grid2 size={2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 1,
            }}
          >
            {showNextLoading && <CircularProgress size={20} />}

            <RectangularTextButton
              colour="highlighted"
              onClick={onNext}
              disabled={disableNext}
              sx={(theme) => ({
                ...(disableNext && {
                  backgroundColor:
                    theme.palette.action.disabledBackground + " !important",
                  color: theme.palette.action.disabled + " !important",
                  cursor: "not-allowed",
                  boxShadow: "none",
                }),
              })}
            >
              {activeStep === steps.length - 1 ? "Finish" : "Next"}
            </RectangularTextButton>
          </Box>
        </Grid2>
      </Grid2>
    </BasePaper>
  );
};

export default DataImportStepperBar;